import React, { useState } from "react";
import { Twitter, Facebook, Link2, Share2, MessageCircle, Check } from "lucide-react";
import { tilesToEmoji } from "./GuessTiles";
import { toast } from "sonner";

export const ShareCard = ({ tiles, resultLabel, mode = "DAILY MOVIE", won }) => {
  const [copied, setCopied] = useState(false);
  const url = window.location.origin;
  const emoji = tilesToEmoji(tiles);
  const shareText =
    `🎬 ABSOLUTE CINEMA\n${emoji}\n${resultLabel}\n\n` +
    (won
      ? `I guessed today's movie in ${resultLabel.split(" ")[0]} attempt(s)! Can you beat me?`
      : `Can you guess today's movie?`);
  const fullText = `${shareText}\n${url}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(fullText);
      setCopied(true);
      toast.success("Result copied to clipboard!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy");
    }
  };

  const native = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "ABSOLUTE CINEMA", text: shareText, url });
      } catch {}
    } else {
      copy();
    }
  };

  const openWin = (u) => window.open(u, "_blank", "noopener,noreferrer");

  const btn =
    "flex items-center justify-center gap-2 px-4 py-3 rounded-xl font-bold text-sm transition-all active:scale-95";

  return (
    <div className="w-full" data-testid="share-section">
      {/* Result card */}
      <div className="ac-card p-5 sm:p-6 text-center mb-4 marquee-border">
        <div className="font-display text-lg font-black tracking-widest ac-gold-text">
          ABSOLUTE CINEMA
        </div>
        <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mt-1">🎬 {mode}</div>
        <div className="text-3xl sm:text-4xl my-4 tracking-widest" data-testid="share-tiles-emoji">
          {emoji}
        </div>
        <div className="font-mono-ac text-2xl font-bold text-zinc-100">{resultLabel}</div>
        <div className="text-xs text-zinc-500 mt-2">
          {won ? "Can you beat me?" : "Can you guess today's movie?"}
        </div>
      </div>

      <div className="text-center text-xs uppercase tracking-[0.25em] text-zinc-400 mb-3">
        Share Result
      </div>
      <div className="grid grid-cols-2 gap-3">
        <button
          data-testid="share-twitter"
          onClick={() => openWin(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(url)}`)}
          className={`${btn} bg-zinc-100 text-black hover:bg-white`}
        >
          <Twitter className="w-4 h-4" /> X / Twitter
        </button>
        <button
          data-testid="share-whatsapp"
          onClick={() => openWin(`https://wa.me/?text=${encodeURIComponent(fullText)}`)}
          className={`${btn} bg-emerald-600 text-white hover:bg-emerald-500`}
        >
          <MessageCircle className="w-4 h-4" /> WhatsApp
        </button>
        <button
          data-testid="share-facebook"
          onClick={() => openWin(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(shareText)}`)}
          className={`${btn} bg-blue-600 text-white hover:bg-blue-500`}
        >
          <Facebook className="w-4 h-4" /> Facebook
        </button>
        <button
          data-testid="share-copy"
          onClick={copy}
          className={`${btn} bg-amber-500/15 border border-amber-500/40 text-amber-200 hover:bg-amber-500/25`}
        >
          {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />}
          {copied ? "Copied!" : "Copy Link"}
        </button>
      </div>
      <button
        data-testid="share-native"
        onClick={native}
        className={`${btn} btn-gold w-full mt-3`}
      >
        <Share2 className="w-4 h-4" /> SHARE RESULT
      </button>
    </div>
  );
};
